import { combineReducers } from "redux";
import { Language, weather } from "../components/Navbar/reducer";

export default combineReducers({
  Language,
  weather,
});
